var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16C21.7956 16 22.5587 16.3161 23.1213 16.8787C23.6839 17.4413 24 18.2044 24 19V19.715C24 23.292 19.79 26 14 26C8.21 26 4 23.433 4 19.715V19C4 18.2044 4.31607 17.4413 4.87868 16.8787C5.44129 16.3161 6.20435 16 7 16H21ZM14 2C14.7879 2 15.5681 2.15519 16.2961 2.45672C17.0241 2.75825 17.6855 3.20021 18.2426 3.75736C18.7998 4.31451 19.2417 4.97595 19.5433 5.7039C19.8448 6.43185 20 7.21207 20 8C20 8.78793 19.8448 9.56815 19.5433 10.2961C19.2417 11.0241 18.7998 11.6855 18.2426 12.2426C17.6855 12.7998 17.0241 13.2417 16.2961 13.5433C15.5681 13.8448 14.7879 14 14 14C12.4087 14 10.8826 13.3679 9.75736 12.2426C8.63214 11.1174 8 9.5913 8 8C8 6.4087 8.63214 4.88258 9.75736 3.75736C10.8826 2.63214 12.4087 2 14 2Z",
    fill: "#B0BEC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileProfile);
export default __webpack_public_path__ + "static/media/mobile-profile.d2a494b90f32c80d7a447f729955fc50.svg";
export { ForwardRef as ReactComponent };